<div id="main-app">
  <sol-loading *ngIf="showLoading"></sol-loading>
  <sol-sidebar *ngIf="isLogged"></sol-sidebar>
  <div id="main-content">
    <router-outlet></router-outlet>
  </div>
  <div
    *ngIf="isLogged"
    style="
      width: 100%;
      text-align: center;
      color: #7c7c7c4a;
      position: absolute;
      top: 97%;
    "
  >
    v. {{ APP_VERSION }}
  </div>
</div>
